import React, { useState, useLayoutEffect, useRef } from 'react';

const DashedBorder = ({
  color = "var(--color-border-default)",
  strokeWidth = 1,
  dashLength = 7,
  dashOffset = 0,
  borderRadius = 12,
}) => {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setDimensions({ width, height });
      }
    });

    observer.observe(containerRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  const { width, height } = dimensions;

  return (
    <div
      ref={containerRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      >
        <rect
          x={strokeWidth / 2.0}
          y={strokeWidth / 2.0}
          width={Math.max(0, width - strokeWidth)}
          height={Math.max(0, height - strokeWidth)}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dashLength + 2} ${dashLength + 2}`}
          strokeDashoffset={dashOffset}
          rx={borderRadius}
          ry={borderRadius}
        />
      </svg>
    </div>
  );
};

export default DashedBorder;
